import React from "react";

export interface BarProps {
  progress: number; // 0~100
  showLabel?: boolean;
}

const GRADIENT =
  "bg-gradient-to-r from-[#cd3ec7] via-50% via-[#5328df] to-[#2d8efa]";

export default function Bar({ progress, showLabel = true }: BarProps) {
  // Clamp progress value
  const percent = Math.max(0, Math.min(progress, 100));
  return (
    <div
      className="box-border flex items-center max-w-[800px] px-[20px] w-[360px] h-[26px]"
      data-name="progress/bar"
    >
      <div className="relative flex-1 py-[8px]">
        {/* Track */}
        <div className="bg-[#eeeeee] h-[10px] rounded-[10px] w-full" />
        {/* Indicator */}
        <div
          className={`${GRADIENT} h-[10px] rounded-[24px] absolute top-1/2 left-0 translate-y-[-50%]`}
          style={{ width: `${percent}%` }}
        />
      </div>
      {showLabel && (
        <div className="ml-[12px] flex items-center font-['Pretendard:ExtraBold',sans-serif] text-[#6d2ef2] text-[14px] tracking-[0.28px] whitespace-nowrap">
          <span>{percent}%</span>
        </div>
      )}
    </div>
  );
}
